import ContractDurationField from './ContractDurationField.component';

export default ContractDurationField;
